import { AdminCreatePanelProps } from './admin-create-panel-props';
import loadable from '@loadable/component';

export const AsyncAdminCreatePanel = loadable<AdminCreatePanelProps>(
  (): Promise<any> => import('./admin-create-panel'),
);
